import "./MainChallenges.scss";

const MainChallenges = () => (
  <section className="challenges" id="challenges">
    <div className="challenges__content" data-aos="fade-up">
      <div className="challenges__header">
        <h2>O desafio que ajudamos a resolver</h2>
        <p>
          Muitas empresas investem em ações pontuais de qualidade de vida, mas encontram
          dificuldades para gerar engajamento, atender às diferentes necessidades dos
          colaboradores e demonstrar resultados concretos para a gestão.
        </p>
      </div>

      <div className="challenges__body">
        <div className="challenges__list-block">
          <p>Como consequência, é comum observar:</p>
          <ul>
            <li>Baixa participação nas ações oferecidas;</li>
            <li>Falta de inovação e interesse ao longo do tempo;</li>
            <li>Pouco impacto na saúde física e emocional das equipes;</li>
            <li>Dificuldade em mensurar resultados e comprovar o retorno do investimento.</li>
          </ul>
        </div>

        <div className="challenges__solution">
          <p>
            A Sodalita transforma esse cenário por meio de programas de bem-estar
            corporativo personalizados, estruturados e alinhados à realidade de cada
            empresa. Nossas soluções são desenvolvidas para aumentar a adesão dos
            colaboradores, fortalecer o clima organizacional e promover saúde e bem-estar
            de forma contínua.
          </p>
          <p>
            Levamos até a sua empresa toda a nossa estrutura e uma equipe própria de
            profissionais qualificados, proporcionando atendimentos diretamente no
            ambiente corporativo. Além disso, cada atendimento gera indicadores e
            relatórios que permitem acompanhar resultados reais, facilitando a tomada de
            decisão e a avaliação do investimento realizado.
          </p>
          <p className="challenges__closing">
            Porque bem-estar não deve ser apenas um benefício. Deve ser uma estratégia
            capaz de desenvolver pessoas, fortalecer equipes e impulsionar resultados para
            a empresa.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default MainChallenges;
